import {
  COACHING_LUCKY_DISCLAIMER,
  computeBiorhythmLucky,
  type Biorhythm,
} from '@mlm/shared/coaching';
import { Eyebrow } from './primitives';

/**
 * The day's lucky colors and its stone, from the member's own cycles. Both are
 * a reflective anchor for setting an intention, which is why the section says
 * so in its own words and again in `COACHING_LUCKY_DISCLAIMER`.
 *
 * Every swatch carries a hairline ring: several of the colors are pale, and on
 * the Daylight ground a bare cream or white circle is invisible.
 */
export function BiorhythmLucky({ reading }: { reading: Biorhythm }) {
  const lucky = computeBiorhythmLucky(reading);
  return (
    <section className="border-b border-border px-5 py-6">
      <Eyebrow className="mb-4">Colors for today</Eyebrow>
      <ul className="flex flex-wrap gap-x-6 gap-y-3">
        {lucky.colors.map((color) => (
          <li key={color.name} className="flex items-center gap-2.5">
            <span
              className="h-7 w-7 shrink-0 rounded-full ring-1 ring-inset ring-[rgba(16,32,26,0.22)]"
              style={{ backgroundColor: color.hex }}
              aria-hidden
            />
            <span className="text-[0.93rem] text-ink">{color.name}</span>
          </li>
        ))}
      </ul>
      <p className="mt-4 text-sm leading-relaxed text-ink/70">{lucky.meaning}</p>

      <Eyebrow className="mb-4 mt-8">Stone for today</Eyebrow>
      <div className="flex items-start gap-3.5">
        <span
          className="mt-0.5 h-9 w-9 shrink-0 rounded-full ring-1 ring-inset ring-[rgba(16,32,26,0.22)]"
          style={{ backgroundColor: lucky.gem.hex }}
          aria-hidden
        />
        <div className="min-w-0">
          <p className="font-display text-[1.1rem] font-semibold leading-snug text-ink">
            {lucky.gem.name}
          </p>
          <p className="mt-1 text-sm leading-relaxed text-ink/70">{lucky.gem.benefit}</p>
        </div>
      </div>
      <p className="mt-6 text-xs leading-relaxed text-muted-foreground">
        {COACHING_LUCKY_DISCLAIMER}
      </p>
    </section>
  );
}
